import { useQuery } from "react-query";
import { getUnreadEmailCount } from "./gateway";

export function useUnreadEmailCount(
  isBusiness?: boolean,
  isNonGemiUser?: boolean,
) {
  return useQuery({
    queryKey: ["unreadEmailCount"],
    queryFn: () => getUnreadEmailCount(),
    // TODO: temporarily disabled, restore: enabled: Boolean(isBusiness || isNonGemiUser),
    enabled: false,
    refetchInterval: 10 * 60 * 1000, // refetch every 10 minutes
  });
}
